import React, { FC, useState } from 'react';

import { Row, Spacer, Column } from '@components/1-atoms/Miscellaneous';
import CardBase /* Card as CardBase */ from '@components/1-atoms/Card';
import Text from '@components/1-atoms/Text';


import { Button } from '@components/2-molecules/Buttons';
import subscription from '@lib/subscription';

import Stripe from '@assets/stripe';
import styled, { css } from '@emotion/native';
import { NavigationProp } from '@react-navigation/native';
import { useUserSubscriptionsManageURL } from '@lib/hooks/useUserSubscription';


const Card = styled(CardBase)` `;


type Props = {
    navigation: NavigationProp<any>;
};

const NoSubscription: FC<Props> = ({ navigation }) => {


    // TODO: Move this at the right place (outside of in a page)
    const [manageURL, ] = useUserSubscriptionsManageURL();

    const _manageSubscription = () =>  subscription.manageSubscription(manageURL?.data);

    return (
        <Card>
            <Row>
                <Column>
                    <Text large>Manage your subscription</Text>
                    <Spacer h={0.3} />
                    <Text color={"#7E7E7E"} small>Inactive or expired subscription</Text>
                </Column>
                <Spacer w={1} />

                <Stripe />
            </Row>
            <Spacer h={2} />

            <Row>
                <Text>Your trial or subscription has expired.{'\n'}Please, manage and validate your subscription to fully use PayBooks.</Text>
            </Row>
            <Spacer h={1} />

            <Button inset outlined onPress={_manageSubscription}>MANAGE SUBSCRIPTION</Button>
        </Card>
    );
};

export default NoSubscription;